import { useQuery } from '@tanstack/react-query';

import { engagementResourcesService } from '../services';

import { engagementResourcesKeys } from './useEngagementResources';

export function useClientEngagement(clientId: string | undefined) {
  return useQuery({
    queryKey: engagementResourcesKeys.operation('client-summary', {
      clientId: clientId ?? '',
    }),
    queryFn: () => {
      if (!clientId) throw new Error('missing clientId');
      return engagementResourcesService.getClientSummary(clientId);
    },
    enabled: Boolean(clientId),
    staleTime: 5 * 60_000,
  });
}
